import { useMemo } from 'react';

import {
  SUGGESTED_ANSWER_EXAMPLE,
  SUGGESTED_ANSWER_FIXED,
  SUGGESTED_ANSWER_VARY,
} from 'global/constants';
import { RichtextDisplay } from '../../teaching-notes/teaching-notes-drawer.style';
import { PStyled } from 'approot/shared/styles/typography.style';
import SuggestedAnswerTitle from '../suggested-answer-title';
import { Box } from 'approot/shared/design-system/box/box.style';
import { getRichtextAnswer } from '../../shared/logic/get-richtext-answer';
import { SUGGESTED_ANSWER_BASE_RICHTEXT } from '../suggested-answer.constants';
import {
  getRichtextValue,
  isRichtextValueEmpty,
} from '../../shared/logic/get-richtext-value';
import SuggestedAnswerExampleRichtext from './suggested-answer-example-richtext';
import { ComponentDiscussion } from '../../component.constants';
import SuggestedAnswerViewBadges from './suggested-answer-view-badges';

type Props = {
  component: ComponentDiscussion;
  isUnitQuiz: boolean;
};

const SuggestedAnswerDiscussionView = ({ component, isUnitQuiz }: Props) => {
  const { id, subActivityProperties, suggestedAnswerProperties, properties } =
    component;
  const answerType = suggestedAnswerProperties?.suggestedAnswerType;

  const hasNoRichTextData = useMemo(
    () =>
      answerType !== SUGGESTED_ANSWER_VARY &&
      suggestedAnswerProperties?.suggestedAnswers?.every(answer =>
        isRichtextValueEmpty(getRichtextAnswer(answer))
      ),
    [answerType, suggestedAnswerProperties]
  );

  return hasNoRichTextData && !isUnitQuiz ? null : (
    <Box>
      <SuggestedAnswerTitle
        isSmall
        label={subActivityProperties?.subActivityLabel}
        instructions={properties.discussion.instruction}
      />

      <SuggestedAnswerViewBadges
        isExampleAnswer={
          answerType === SUGGESTED_ANSWER_EXAMPLE && !hasNoRichTextData
        }
        isFixedAnswer={
          answerType === SUGGESTED_ANSWER_FIXED && !hasNoRichTextData
        }
        suggestedAnswerScore={suggestedAnswerProperties?.suggestedAnswersScore}
        isUnitQuiz={isUnitQuiz}
      />

      {answerType === SUGGESTED_ANSWER_VARY ? (
        <PStyled>Answers may vary</PStyled>
      ) : answerType === SUGGESTED_ANSWER_EXAMPLE ? (
        <SuggestedAnswerExampleRichtext
          id={id}
          suggestedAnswerProperties={suggestedAnswerProperties}
        />
      ) : (
        <>
          {suggestedAnswerProperties?.suggestedAnswers?.map(answer => {
            return !isRichtextValueEmpty(getRichtextAnswer(answer)) ? (
              <RichtextDisplay
                key={answer.uuid}
                dangerouslySetInnerHTML={{
                  __html: getRichtextValue(
                    getRichtextAnswer(answer),
                    SUGGESTED_ANSWER_BASE_RICHTEXT
                  ),
                }}
              />
            ) : null;
          })}
        </>
      )}
    </Box>
  );
};

export default SuggestedAnswerDiscussionView;
